import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=58217d11&scoped=true&"
import script from "./addRecord.vue?vue&type=script&lang=js&"
export * from "./addRecord.vue?vue&type=script&lang=js&"
import style0 from "./addRecord.vue?vue&type=style&index=0&id=58217d11&prod&lang=scss&"
import style1 from "./addRecord.vue?vue&type=style&index=1&id=58217d11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58217d11",
  null
  
)

export default component.exports